import { createTheme } from '@mui/material';
import { blue, green, grey, lightBlue } from '@mui/material/colors';

export const LightCyberpunkTheme = createTheme({
  palette: {
    primary: {
      main: blue[700], // Azul para transmitir confiança e tecnologia
      dark: blue[800], // Tom mais profundo para contraste
      light: blue[400], // Azul claro para detalhes
      contrastText: '#ffffff', // Texto branco para clareza
    },
    secondary: {
      main: green[500], // Verde para simbolizar conexão e progresso
      dark: green[700], 
      light: green[300], 
      contrastText: '#ffffff', // Texto branco para complementar
    },
    background: {
      paper: '#ffffff', // Fundo branco limpo
      default: grey[100], // Cinza muito claro para um visual moderno e neutro
    },
    text: {
      primary: grey[800], // Texto principal em cinza escuro para boa leitura
      secondary: lightBlue[700], // Destaques em azul claro para contraste
    },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif", // Fonte moderna e confiável
    h1: {
      fontSize: '2rem', // Título principal
      fontWeight: 600, // Peso para dar destaque
      color: blue[700],
    },
    button: {
      textTransform: 'none', // Botões sem transformação de texto
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px', // Bordas suaves
          border: '1px solid', // Borda fina para destaque
          borderColor: green[500], // Verde para reforçar o tema
          textShadow: '0 0 2px rgba(0, 0, 0, 0.1)', // Sutil sombra para contraste
          '&:hover': {
            backgroundColor: green[600], // Verde mais escuro no hover
            borderColor: green[700], // Destaque na borda
            textShadow: '0 0 4px rgba(0, 0, 0, 0.2)', // Sombra mais intensa
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff', // Fundo claro para um layout limpo
          color: grey[800], // Texto em cinza escuro para leitura confortável
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', // Sombra para criar profundidade
          borderRadius: '12px', // Bordas suaves
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontWeight: 400, // Peso de fonte confortável
          lineHeight: 1.5, // Boa espaçamento para legibilidade
        },
      },
    },
  },
});
